(function () {
  function normalize(value) {
    return (value || '')
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  function setupCountryFilter(scope) {
    var roots = (scope || document).querySelectorAll('.kenze-footer-localization localization-form-component');

    roots.forEach(function (root) {
      var input = root.querySelector('.country-filter__input');
      var reset = root.querySelector('.country-filter__reset-button');
      var noResults = root.querySelector('#no-results-message');
      var lists = root.querySelectorAll('ul.countries, ul.popular-countries');
      var items = root.querySelectorAll('.localization-form__list-item[role="option"]');

      if (!input || !items.length || input.dataset.kenzeFilterFixed === 'true') return;
      input.dataset.kenzeFilterFixed = 'true';

      function runFilter() {
        var query = normalize(input.value);
        var visibleCount = 0;

        if (reset) reset.toggleAttribute('hidden', !query);

        lists.forEach(function (list) {
          if (list.classList.contains('popular-countries')) {
            list.toggleAttribute('hidden', !!query);
          }
        });

        items.forEach(function (item) {
          var country = normalize(item.querySelector('.country') ? item.querySelector('.country').textContent : item.textContent);
          var iso = normalize(item.getAttribute('data-value'));
          var aliases = normalize(item.getAttribute('data-aliases'));
          var match = !query || country.indexOf(query) !== -1 || iso.indexOf(query) !== -1 || aliases.indexOf(query) !== -1;

          item.toggleAttribute('hidden', !match);
          if (match) visibleCount += 1;
        });

        if (noResults) noResults.toggleAttribute('hidden', visibleCount > 0);
      }

      input.addEventListener('input', runFilter);
      input.addEventListener('keyup', runFilter);

      if (reset) {
        reset.addEventListener('click', function () {
          window.setTimeout(runFilter, 0);
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () { setupCountryFilter(document); });
  document.addEventListener('shopify:section:load', function (event) { setupCountryFilter(event.target); });
})();
